<template>
  <div class="backdrop" v-if="state.visible">
    <div class="popup" :class="popupClass">
      <div class="container">
        <div class="d-flex justify-content-between align-items-center" v-if="!hideCloseBtn">
          <h1 class="m-0 p-0">{{title}}</h1>
          <button @click.prevent="props.hide && props.hide() || hide()" class="btn btn-secondary btn-close-popup"><img alt="close" src="/img/close.svg"></button>
        </div>
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import {reactive} from "@vue/reactivity";
const emit = defineEmits(['onHide'])
const props = defineProps<{
  title?: string|null
  hide?: () => {}|null,
  hideCloseBtn?: boolean,
  popupClass?: string|null
}>()
const state = reactive({
  visible: false
});

const show = () => {
  state.visible = true;
}

const hide = () => {
  state.visible = false;
  emit('onHide')
}

const isVisible = (): boolean => {
  return state.visible;
}

defineExpose({ show, hide, isVisible})
</script>